"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports._ModuleToSettingsMapping = exports._LegacyMapping = exports._AllModuleBlueprints = exports._StripeChangePaymentMethodReferences = exports._MembershipCompletionReferences = exports._FitsignReference = exports._FitssoExpressReference = exports._StudioSelectionReferences = exports._MembershipSelectionReferences = exports._AddonSelectionReferences = exports._DocumentationReferences = exports._AdditionalReferralReferences = exports._AdditionalMembershipCompletionReferences = exports._AdditionalLeadFormReferences = exports._AdditionalicePreviewReferences = exports._AdditionalClassesReferences = exports._ClassesReferences = exports._PricePreviewReferences = exports._TrialBookingModularReferences = exports._TrialBookingReferences = void 0;
var offline_fms_1 = require("@src/modules/fitfms/offline-fms");
var self_service_membership_upgrade_1 = require("@src/modules/fitfms/self-service/self-service-membership-upgrade");
var self_service_references_1 = require("@src/modules/fitfms/self-service/self-service-references");
var leaderboard_module_1 = require("@src/modules/fitgames/leaderboard.module");
var missing_payment_v2_1 = require("@src/modules/fitpay/missing-payment-v2");
var fitpos_1 = require("@src/modules/fitpos/fitpos");
var fitsign_1 = require("@src/modules/fitsign/fitsign");
var fitsso_express_1 = require("@src/modules/fitsso/fitsso-express");
var shared_1 = require("@src/modules/shared");
var variables_const_1 = require("@src/variables.const");
var documentation_module_1 = require("../modules/documentation/documentation.module");
var dropdown_module_1 = require("../modules/dropdown/dropdown.module");
var addon_selection_1 = require("../modules/fitfms/addon-selection/addon-selection");
var lead_form_1 = require("../modules/fitfms/lead-form/lead-form");
var membership_completion_1 = require("../modules/fitfms/membership-completion/membership-completion");
var membership_selection_1 = require("../modules/fitfms/membership-selection/membership-selection");
var price_preview_1 = require("../modules/fitfms/price-preview/price-preview");
var studio_selection_1 = require("../modules/fitfms/studio-selection/studio-selection");
var profile_edit_1 = require("../modules/fitfms/success/profile-edit");
var trial_booking_modular_module_1 = require("../modules/fitfms/trial-booking/trial-booking-modular.module");
var trial_booking_module_1 = require("../modules/fitfms/trial-booking/trial-booking.module");
var keycloak_form_1 = require("../modules/fitsso/keycloak-form");
var checkout_documentation_1 = require("./documentations/checkout.documentation");
var trialbooking_documentation_1 = require("./documentations/trialbooking.documentation");
var input_mapping_const_1 = require("./input.mapping.const");
var self_service_landing_1 = require("@src/modules/fitfms/self-service/self-service-landing");
var self_service_module_upgrade_1 = require("@src/modules/fitfms/self-service/self-service-module-upgrade");
var preview_module_1 = require("@src/modules/shared/preview/preview-module");
var preview_references_const_1 = require("@src/modules/shared/preview/preview-references.const");
var self_service_update_customer_1 = require("@src/modules/fitfms/self-service/self-service-update-customer");
var classes_module_1 = require("@src/modules/fitfms/classes/classes.module");
var self_service_fittec_wrapped_service_1 = require("@src/modules/fitfms/self-service/fittec-wrapped/self-service-fittec-wrapped.service");
var fittec_wrapped_references_const_1 = require("@src/modules/fitfms/self-service/fittec-wrapped/fittec-wrapped-references.const");
var self_service_appointments_1 = require("@src/modules/fitfms/self-service/self-service-appointments");
exports._TrialBookingReferences = {
    studioDropdown: {
        uid: 'studio-dropdown',
        required: false,
        description: 'Select element for the studio selection',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    studioSearch: {
        uid: 'studio-search',
        required: false,
        description: 'Optional search input to filter studios',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    trialbookingFriendForm: {
        uid: 'trialbookingFriendForm',
        required: false,
        description: 'Optional friend form template. Put it inside a wrapper so that wrapper can be hidden; one clone is shown when data-get="bringsAFriend" is enabled.',
    },
};
exports._TrialBookingModularReferences = {
    noTrialSessionBookable: {
        uid: 'no-trialsession-bookable',
        required: false,
        description: 'Optional warning template removed from the DOM during setup and cloned into the datepicker container instead of the calendar when trialSessionBookable=false. Supports data-get="trialbooking-description" inside. A translated error div is used when missing.',
    },
    studioStep: {
        uid: 'studio-step',
        required: false,
        description: 'Optional step container for selecting a studio. The whole container is shown or hidden by module state.',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    datepickerStep: {
        uid: 'datepicker-step',
        required: true,
        description: 'Step container shown while selecting a trial booking date.',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    datepicker: {
        uid: 'datepicker',
        required: true,
        description: 'Container inside the datepicker step where the module appends the ci-datepicker. Selecting a valid date saves trialbooking_date in localStorage as YYYY-MM-DD and clears trialbooking_time.',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    slotpickerStep: {
        uid: 'slotpicker-step',
        required: false,
        description: 'Step container shown while selecting a trial booking slot.',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    slotpicker: {
        uid: 'slotpicker',
        required: true,
        description: 'Marker inside the slotpicker step. Generated slot content is appended to this element parent. Selecting a valid slot saves its start time in localStorage as trialbooking_time (HH:mm, using the slot timestamp). Changing the studio clears the saved date and time; changing the trainer filter clears the time.',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    formStep: {
        uid: 'form-step',
        required: true,
        description: 'Step container with the customer form fields and submit button.',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    studioDropdown: {
        uid: 'studio-dropdown',
        required: false,
        description: 'Select element for the studio selection',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    studioSearch: {
        uid: 'studio-search',
        required: false,
        description: 'Optional search input to filter studios',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
    trialbookingFriendForm: {
        uid: 'trialbookingFriendForm',
        required: false,
        description: 'Optional friend form template. Put it inside a wrapper so that wrapper can be hidden; one clone is shown when data-get="bringsAFriend" is enabled.',
    },
};
exports._PricePreviewReferences = {
    optionalModules: {
        uid: 'optional-modules',
        required: false,
        description: 'Container that will be replicated for each module, inside data-get can be used for each attribute of a module',
    },
    fees: {
        uid: 'fees',
        required: false,
        description: 'Container that will be replicated for each fee, inside data-get can be used for each attribute of a fee',
    },
    validateVoucher: {
        uid: 'validate-voucher',
        required: false,
        description: 'Clicking on this element will trigger a voucher validation',
        dontRemoveFromDom: true,
        keepRefTag: true,
    },
};
exports._ClassesReferences = {
    classesContainer: {
        uid: 'classes-container',
        required: true,
        dontRemoveFromDom: true,
        keepRefTag: true,
        description: 'Container where the classes module builds a responsive class schedule grid.',
    },
    classesHeaderDefault: {
        uid: 'classes-header-default',
        required: true,
        description: 'Header template used for every weekday. Inside data-get can be used for weekday, weekdayShort, date, dateIso, or isToday.',
    },
    classesHeaderToday: {
        uid: 'classes-header-today',
        required: false,
        description: 'Optional header template used for today. Falls back to classes-header-default when missing.',
    },
    classesEntryDefault: {
        uid: 'classes-entry-default',
        required: true,
        description: 'Class entry template used for every class. Inside data-get can be used for class slot attributes.',
    },
    classesEntryToday: {
        uid: 'classes-entry-today',
        required: false,
        description: 'Optional class entry template used for classes on today. Falls back to classes-entry-default when missing.',
    },
    mobileNavButton: {
        uid: 'mobile-nav-button',
        required: true,
        description: 'Mobile weekday navigation button template. Used for inactive weekdays. Inside data-get can be used for weekday, weekdayShort, date, dateIso, or isToday.',
    },
    mobileNavButtonActive: {
        uid: 'mobile-nav-button-active',
        required: true,
        description: 'Mobile weekday navigation button template. Used for the selected weekday. Inside data-get can be used for weekday, weekdayShort, date, dateIso, or isToday.',
    },
    studioFilterCheckbox: {
        uid: 'classes-studio-filter-checkbox',
        required: false,
        description: 'Checkbox label template that will be replicated for each studio and reload classes when changed.',
    },
    locationFilterCheckbox: {
        uid: 'classes-location-filter-checkbox',
        required: false,
        description: 'Checkbox label template that will be replicated for each class location and filter loaded classes when changed.',
    },
    categoryFilterCheckbox: {
        uid: 'classes-category-filter-checkbox',
        required: false,
        description: 'Checkbox label template that will be replicated for each class category and filter loaded classes when changed.',
    },
    trainerFilterCheckbox: {
        uid: 'classes-trainer-filter-checkbox',
        required: false,
        description: 'Checkbox label template that will be replicated for each class trainer and filter loaded classes when changed.',
    },
};
exports._AdditionalClassesReferences = {
    name: {
        dataTag: 'get',
        uid: 'name',
        required: false,
        description: 'Class title. Alias for classInformation.title.',
    },
    title: {
        dataTag: 'get',
        uid: 'title',
        required: false,
        description: 'Class title. Alias for classInformation.title.',
    },
    description: {
        dataTag: 'get',
        uid: 'description',
        required: false,
        description: 'Class description. Alias for classInformation.description.',
    },
    category: {
        dataTag: 'get',
        uid: 'category',
        required: false,
        description: 'Class category. Alias for classInformation.category.',
    },
    duration: {
        dataTag: 'get',
        uid: 'duration',
        required: false,
        description: 'Class duration. Alias for classInformation.duration.',
    },
    date: {
        dataTag: 'get',
        uid: 'date',
        required: false,
        description: 'Formatted class date based on startDateTime.',
    },
    startTime: {
        dataTag: 'get',
        uid: 'startTime',
        required: false,
        description: 'Formatted class start time based on startDateTime.',
    },
    endTime: {
        dataTag: 'get',
        uid: 'endTime',
        required: false,
        description: 'Formatted class end time based on endDateTime.',
    },
    location: {
        dataTag: 'get',
        uid: 'location',
        required: false,
        description: 'Class location name. Alias for location.name.',
    },
    instructors: {
        dataTag: 'get',
        uid: 'instructors',
        required: false,
        description: 'Comma separated class instructor names.',
    },
    classSlotAttribute: {
        dataTag: 'get',
        uid: '[class slot path]',
        required: false,
        description: 'Any class slot path can be used, for example id, startDateTime, endDateTime, classInformation.title, or location.name.',
    },
};
exports._AdditionalicePreviewReferences = {
    key: {
        dataTag: 'get',
        uid: '[key]',
        required: false,
        description: 'Any key of a rate bundle, term, module, fee, etc. example keys can be checked here: https://vamos-ab-city.api.magicline.com/connect/v1/rate-bundle?studioId=1210006110',
    },
    price: {
        dataTag: 'get',
        uid: 'price',
        required: false,
        description: 'Term price, adjusted with voucher discounts, or module price',
    },
    originalPrice: {
        dataTag: 'get',
        uid: 'originalPrice',
        required: false,
        description: 'Term price, before the voucher code. Automatically hidden, if no voucher applied.',
    },
    term: {
        dataTag: 'get',
        uid: 'term',
        required: false,
        description: 'Term duration, like 12 Months',
    },
    contractTotalValue: {
        dataTag: 'get',
        uid: 'contractTotalValue',
        required: false,
        description: 'Total contract value after minimum term duration',
    },
    contractTotalMembership: {
        dataTag: 'get',
        uid: 'contractTotalMembership',
        required: false,
        description: 'Total membership price after minimum term duration',
    },
    contractTotalFees: {
        dataTag: 'get',
        uid: 'contractTotalFees',
        required: false,
        description: 'Total fees after minimum term duration',
    },
    contractTotalModules: {
        dataTag: 'get',
        uid: 'contractTotalModules',
        required: false,
        description: 'Total module price after minimum term duration',
    },
    cancellation: {
        dataTag: 'get',
        uid: 'cancellation',
        required: false,
        description: 'Cancellation period, like 1 Month',
    },
    bonusPeriod: {
        dataTag: 'get',
        uid: 'bonusPeriod',
        required: false,
        description: 'Bonus period, like 1 Month',
    },
    adjustmentRules: {
        dataTag: 'get',
        uid: 'adjustmentRules',
        required: false,
        description: 'Textblock describing price adjustment rules',
    },
    paymentFrequency: {
        dataTag: 'get',
        uid: 'paymentFrequency',
        required: false,
        description: 'Payment frequency, can be used for modules and term. E.g. weekly, or every 2 months',
    },
    firstPayment: {
        dataTag: 'get',
        uid: 'firstPayment',
        required: false,
        description: 'Total first payment, sum of membership base price, all addons, all fees',
    },
    totalModulePrice: {
        dataTag: 'get',
        uid: 'totalModulePrice',
        required: false,
        description: 'Total price of all selected modules (addons)',
    },
    totalRecurringPrice: {
        dataTag: 'get',
        uid: 'totalRecurringPrice',
        required: false,
        description: 'Total price of the membership and all selected modules (addons)',
    },
    totalRecurringOriginalPrice: {
        dataTag: 'get',
        uid: 'totalRecurringOriginalPrice',
        required: false,
        description: 'Total price of the membership and all selected modules (addons), not adjusted by voucher codes. Hidden by default, until a valid voucher was added.',
    },
    totalFeePrice: {
        dataTag: 'get',
        uid: 'totalFeePrice',
        required: false,
        description: 'Total price of all fees',
    },
    preUseCharge: {
        dataTag: 'get',
        uid: 'preUseCharge',
        required: false,
        description: 'Pre use cost for the member',
    },
    preUseTimeframe: {
        dataTag: 'get',
        uid: 'preUseTimeframe',
        required: false,
        description: 'If the contract is set to cost for preuse, this will be the timeframe they pay the preuse charge for. Will be "-" if contract has no preuse fee.',
    },
};
exports._AdditionalLeadFormReferences = {
    consents: {
        dataTag: 'consent',
        uid: 'letter, email, textMessage, phone, mySportsMessage',
        required: false,
        description: 'If a checkbox has data-consent set and a user checks it, the consent will be added to the system. By default not required, make sure to also use data-checkox="required" or optional.',
    },
    checkboxes: {
        dataTag: 'checkbox',
        uid: 'required, optional',
        required: false,
        description: 'Additional checkboxes to be validated by our framework. Default is required.',
    },
};
exports._AdditionalMembershipCompletionReferences = {
    paymentChoice: {
        dataTag: 'get',
        uid: 'customer.paymentChoice',
        required: false,
        description: 'Optional select element inside membership-completion. Allowed option values: DIRECT_DEBIT, BANK_TRANSFER, CASH, CREDIT_CARD, TWINT. The browser-selected default is applied on load and updates on change. If absent, DIRECT_DEBIT is always used, ignoring stored choices. If present, an empty or unsupported value blocks submission. Works with and without offlineFMS; the choice is forwarded to unified contract creation. Non-DIRECT_DEBIT choices hide IBAN, account holder, and SEPA consent, disable their inputs, clear their errors, and omit the bank account. Fields are found by data-get or data-set with customer.bankAccount.iban, customer.bankAccount.accountHolder, or customer.bankAccount.consent, or by the mapped legacy IDs accountIban, accountHolder, and checkboxConsent. The immediate parent of checkboxConsent is also hidden to include the custom checkbox visual and consent text. Switching back shows and enables the fields and shows the consent parent. Other required checkboxes remain required. This selects the contract payment method; it does not collect a payment.',
    },
    referralCode: {
        dataTag: 'get',
        uid: 'customer.referralCode',
        required: false,
        description: 'An input that can be used for customers to enter the referral code of another person for potential benefits.',
        legacy: 'referralCode',
    },
    voucherCode: {
        dataTag: 'get',
        uid: input_mapping_const_1._AllMappings.voucherCode.uid,
        required: false,
        description: 'An input that can be used for customers to enter a voucher code for a given contract.',
        legacy: input_mapping_const_1._AllMappings.voucherCode.uid,
    },
};
exports._AdditionalReferralReferences = {
    highlight: {
        dataTag: 'ref',
        uid: 'highlight',
        required: true,
        description: 'Container that will be duplicated for each scoreboard entry. Inside you can use data-get to get: placement, referralCode, totalScore, totalCheckins, totalReferrals',
    },
    gameName: {
        dataTag: 'get',
        uid: 'gameName',
        required: false,
        description: 'Displays the game name',
    },
    lastGameUpdate: {
        dataTag: 'get',
        uid: 'lastGameUpdate',
        required: false,
        description: 'Displays the last update time for the game in UTC',
    },
    totalActivePlayers: {
        dataTag: 'get',
        uid: 'total-active-players',
        required: false,
        description: 'Displays total active players for the game, requires use of {{data}} as placeholder inside, which will be replaced.',
    },
};
exports._DocumentationReferences = {
    moduleMapping: {
        uid: 'module-mapping',
        required: true,
        refObjects: {
            attributeMapping: {
                uid: 'attribute-mapping',
                required: true,
                description: '',
            },
        },
        description: '',
    },
    getterMappingEntry: {
        uid: 'getter-mapping-entry',
        required: true,
        description: '',
    },
    sidebarNavigation: {
        uid: 'sidebar-navigation',
        required: true,
        description: '',
    },
    allSettings: {
        uid: 'all-settings',
        required: false,
        description: 'Container for all settings string',
        dontRemoveFromDom: true,
    },
};
exports._AddonSelectionReferences = {
    modules: {
        uid: 'no-modules',
        legacy: (_a = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.modules) === null || _a === void 0 ? void 0 : _a.refObjectNoModule,
        description: 'Will be rendered if no modules are assigned to the contract',
    },
    refObjectNoModule: {
        uid: 'no-modules',
        legacy: (_b = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.modules) === null || _b === void 0 ? void 0 : _b.refObjectNoModule,
        description: 'Will be rendered if no modules are assigned to the contract',
    },
    selectableModules: {
        uid: 'selectable-modules',
        legacy: (_c = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.modules) === null || _c === void 0 ? void 0 : _c.refObjectSelectableModules,
        description: 'Modules / addons that can be selected by the user',
    },
    selectedSelectableModules: {
        // name is important for dynamic code
        uid: 'selected-modules',
        legacy: (_d = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.modules) === null || _d === void 0 ? void 0 : _d.refObjectSelectedModules,
        description: 'If user selected a data-ref"selectable-modules" this element will replace it',
    },
    optionalModules: {
        uid: 'optional-modules',
        legacy: (_e = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.modules) === null || _e === void 0 ? void 0 : _e.refObjectOptionalModules,
        description: 'Modules / addons that will cost extra in the membership',
    },
    selectedOptionalModules: {
        uid: 'selected-optional-modules',
        legacy: (_f = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.modules) === null || _f === void 0 ? void 0 : _f.refObjectSelectedOptionalModules,
        description: 'If user selected a data-ref="selected-optional-modules" this element will replace it',
    },
};
exports._MembershipSelectionReferences = {
    regularContract: {
        required: true,
        uid: 'regular-contract',
        legacy: variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.refObjectId,
        description: 'Regular contracts will be shown like this',
    },
    featuredContract: {
        uid: 'featured-contract',
        legacy: (_g = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.checkout) === null || _g === void 0 ? void 0 : _g.featuredRefId,
        description: 'Typically there is just one extra fancy / prominent contract which is called a featured',
    },
    subdescription: {
        uid: 'subdescription',
        legacy: (_h = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.checkout) === null || _h === void 0 ? void 0 : _h.refObjectSubdescription,
        description: 'This will be rendered for each aspect of the contract',
    },
    termSwitcher: {
        dontRemoveFromDom: true,
        uid: 'term-switcher',
        legacy: 'term-switcher',
        description: 'This will be rendered for each aspect of the contract',
    },
    membershipSubmit: {
        dontRemoveFromDom: true,
        uid: 'membership-submit',
        legacy: 'Membership-Submit',
        description: 'Button to select the membership',
        required: true,
    },
};
exports._StudioSelectionReferences = {
    location: {
        required: true,
        uid: 'location',
        legacy: variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.refObjectId,
        description: 'Location reference, will be used as template for all studios',
    },
    locationWrapper: {
        dontRemoveFromDom: true,
        required: true,
        uid: 'location-wrapper',
        legacy: 'location-wrapper',
        description: 'Location wrapper, all studios will be shown inside this',
    },
    locationSearch: {
        dontRemoveFromDom: true,
        required: true,
        uid: 'location-search',
        legacy: 'location-search',
        description: 'Search bar wrapper, search bar will be shown here',
    },
    searchResultsWrapper: {
        dontRemoveFromDom: true,
        required: true,
        uid: 'search-results-wrapper',
        legacy: 'search-results-wrapper',
        description: 'Search Wrapper, all search results will be shown here',
    },
    studioMap: {
        dontRemoveFromDom: true,
        uid: 'map',
        description: 'Show an open streetmap',
    },
};
exports._FitssoExpressReference = {
    socials: {
        dontRemoveFromDom: true,
        uid: 'socials',
        description: 'Social logins',
        required: true,
    },
};
exports._FitsignReference = {
    submit: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'fitsign-submit',
        description: 'Button after you sign for your underager',
        required: false,
    },
};
exports._MembershipCompletionReferences = {
    membershipComplete: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'membership-complete',
        legacy: 'Membership-Submit',
        description: 'Button that will complete the membership',
        required: true,
    },
    webflowSubmit: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'webflow-submit',
        legacy: 'webflowSubmitButton',
        description: 'Button will send the webflow form if valid, should be hidden',
        required: false,
    },
    fitpayPaymentSwitcher: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'fitpay-payment-switcher',
        description: 'A switch to change between fitpay and old sepa payment',
        required: false,
    },
    fitpayPaymentSuccessful: {
        uid: 'fitpay-payment-successful',
        description: 'A container that will be displayed on the page if the payment was successful, but extra data is missing',
        required: false,
    },
    fitpayCheckout: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'stripe-payment-container',
        description: 'Container for the stripe payments module, required if you use fitpay',
        required: false,
    },
    fitpayExpressCheckout: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'stripe-payment-express-container',
        description: 'Container for the stripe express checkout module',
        required: false,
    },
    removeOnDisabledFitpay: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'remove-on-disabled-fitpay',
        description: 'If fitpay is disabled or fails to initialize, these containers will be removed as well.',
        required: false,
    },
    leadForm: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'lead-form',
        description: 'Lead form, has to be on a form element. Will be submitted in addition to the membership-completion form',
        required: false,
    },
    signField: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'sign-field',
        description: 'Optional signfield for themisoft. Renders a signfield in this container',
        required: false,
    },
    signFieldClearButton: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'sign-field-clear-button',
        description: 'Any element that will trigger on click to clear the sign-field if it exists',
        required: false,
    },
    magiclinePaymentsElementRecuring: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'magicline-payments-container-recuring',
        description: 'Container for the magicline payments module for the recuring payment',
        required: false,
    },
    magiclinePaymentsElementUpfront: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'magicline-payments-container-upfront',
        description: 'Container for the magicline payments module for upfront payments',
        required: false,
    },
    contractPreviewDownload: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'download-contract-preview',
        description: 'A click on this element will try to download a contract preview PDF file.',
        required: false,
    },
};
exports._StripeChangePaymentMethodReferences = {
    changePaymentMethodContainer: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'change-payment-method-container',
        description: 'Container for the Stripe change payment method widget. Express and regular checkout are mounted here.',
        required: true,
    },
    submit: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'membership-complete',
        legacy: 'Membership-Submit',
        description: 'Button that confirms the selected Stripe payment method.',
        required: false,
    },
    webflowSubmit: {
        dontRemoveFromDom: true,
        keepRefTag: true,
        uid: 'webflow-submit',
        legacy: 'webflowSubmitButton',
        description: 'Hidden button used to send the Webflow form after the payment method was changed successfully.',
        required: false,
    },
    success: {
        uid: 'stripe-payment-successful',
        description: 'Container displayed when the payment method was changed successfully and no Webflow submit exists.',
        required: false,
    },
};
exports._AllModuleBlueprints = __assign(__assign({ 'studio-selection': {
        class: studio_selection_1.Location,
        references: exports._StudioSelectionReferences,
    }, 'membership-selection': {
        class: membership_selection_1.Checkout,
        docuAdditions: checkout_documentation_1._MembershipSelectionCustomReferences,
        references: exports._MembershipSelectionReferences,
    }, 'addon-selection': {
        class: addon_selection_1.ContractModules,
        references: exports._AddonSelectionReferences,
    }, 'lead-form': {
        class: lead_form_1.LeadForm,
        docuAdditions: exports._AdditionalLeadFormReferences,
    }, 'membership-completion': {
        class: membership_completion_1.Form,
        references: exports._MembershipCompletionReferences,
        docuAdditions: exports._AdditionalMembershipCompletionReferences,
    }, 'profile-edit-fms': {
        class: profile_edit_1.ProfileEdit,
    }, 'missing-fitpay-payment': {
        class: missing_payment_v2_1.MissingFitpayPaymentV2,
        references: exports._MembershipCompletionReferences,
    }, 'stripe-change-payment-method': {
        lazyClass: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@src/modules/fitpay/stripe-change-payment-method')); })];
                case 1: return [2 /*return*/, (_a.sent()).StripeChangePaymentMethod];
            }
        }); }); },
        references: exports._StripeChangePaymentMethodReferences,
    }, 'price-preview': {
        class: price_preview_1.PricePreview,
        references: exports._PricePreviewReferences,
        docuAdditions: exports._AdditionalicePreviewReferences,
    }, 'fitsso-registration': {
        class: keycloak_form_1.KeycloakForm,
    }, 'fitsso-express': {
        class: fitsso_express_1.FitssoExpress,
        references: exports._FitssoExpressReference,
    }, fitsign: {
        class: fitsign_1.FitSign,
        references: exports._FitsignReference,
    }, 'trial-booking': {
        class: trial_booking_module_1.TrialBookingModule,
        docuAdditions: trialbooking_documentation_1._TrialBookingCustomReferences,
        references: exports._TrialBookingReferences,
    }, 'trial-booking-modular': {
        class: trial_booking_modular_module_1.TrialBookingModularModule,
        docuAdditions: trialbooking_documentation_1._TrialBookingModularCustomReferences,
        references: exports._TrialBookingModularReferences,
    }, classes: {
        class: classes_module_1.ClassesModule,
        references: exports._ClassesReferences,
        docuAdditions: exports._AdditionalClassesReferences,
    }, 'fittec-wrapped': {
        class: self_service_fittec_wrapped_service_1.FittecWrappedModule,
        references: fittec_wrapped_references_const_1._SelfServiceFittecWrappedReferences,
    }, 'self-service-landing': {
        class: self_service_landing_1.SelfServiceLanding,
    }, 'self-service-appointments': {
        class: self_service_appointments_1.SelfServiceAppointments,
        references: self_service_references_1._SelfServiceAppointmentsReferences,
    }, 'self-service-membership-upgrade': {
        class: self_service_membership_upgrade_1.SelfServiceMembershipUpgrade,
        references: self_service_references_1._SelfServiceMembershipUpgradeReferences,
    }, 'self-service-module-upgrade': {
        class: self_service_module_upgrade_1.SelfServiceModuleUpgrade,
        references: self_service_references_1._SelfServiceModuleUpgradeReferences,
    }, 'self-service-update-customer': {
        class: self_service_update_customer_1.SelfServiceUpdateCustomer,
        references: {},
    }, dropdown: {
        class: dropdown_module_1.DropDownModule,
    }, documentation: {
        class: documentation_module_1.DocumentationModule,
        references: exports._DocumentationReferences,
    }, fitpos: {
        class: fitpos_1.Fitpos,
    }, preview: {
        class: preview_module_1.PreviewModule,
        references: preview_references_const_1._PreviewReferences,
    }, 
    /**
     * FITGAMES
     */
    highscore: {
        class: leaderboard_module_1.LeaderboardModule,
        docuAdditions: exports._AdditionalReferralReferences,
    } }, shared_1.SharedModuleBlueprints), offline_fms_1.OfflineFMSModules);
/**
 * @deprecated Legacy module mapping
 */
exports._LegacyMapping = {
    finish: exports._AllModuleBlueprints['membership-completion'],
    checkout: exports._AllModuleBlueprints['membership-selection'],
    modules: exports._AllModuleBlueprints['addon-selection'],
    success: exports._AllModuleBlueprints['profile-edit-fms'],
    location: exports._AllModuleBlueprints['studio-selection'],
    leadform: exports._AllModuleBlueprints['lead-form'],
    fitpos: exports._AllModuleBlueprints['fitpos'],
    'missing-stripe-payment': exports._AllModuleBlueprints['missing-stripe-payment'],
};
/**
 * @deprecated Legacy module mapping
 */
exports._ModuleToSettingsMapping = {
    'membership-completion': 'finish',
    'membership-selection': 'checkout',
    'addon-selection': 'modules',
    'profile-edit-fms': 'success',
    'studio-selection': 'location',
    'lead-form': 'leadForm',
    fitpos: 'fitpos',
    'missing-stripe-payment': 'missing-stripe-payment',
};
